module.exports = __webpack_public_path__ + "static/media/hubconnect.ecd89850.md";